import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import { useState } from 'react';

interface RefreshButtonProps {
  onRefresh: () => void;
  disable?: boolean;
}
export const RefreshButton = ({ onRefresh, disable }: RefreshButtonProps) => {
  const [rotateIcon, setRotateIcon] = useState(0);

  const handleRefreshClick = () => {
    setRotateIcon(rotateIcon + 1);
    onRefresh();
  };

  const button = (
    <IconButton
      size="large"
      color="primary"
      onClick={handleRefreshClick}
      disabled={disable}
      type="button"
    >
      <CachedOutlinedIcon
        sx={{
          fontSize: '2rem',
          transition: 'transform 1s ease',
          transform: `rotate(${rotateIcon * 360}deg)`,
        }}
      />
    </IconButton>
  );

  return (
    <Tooltip arrow title="Refresh" placement="top">
      {disable ? <span>{button}</span> : button}
    </Tooltip>
  );
};
